import React, {useState, useEffect} from 'react';
import PubSub from 'services/PubSub/';
import LoginService from "services/Login/";
import Modal from 'components/Modal';
import { actionsType } from 'config/constants';
import AddToList from './AddToList';
import style from './style.scss'; //NOSONAR

let actions = [];

const ModalAddToList = () => {

    const [headerCheckout, setHeaderCheckout] = useState(false);

    const [payload, setPayload] = useState(null);
    
    
    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.ADD_TO_LIST_OPEN, _openModalModalAddToList));

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
        };
    }, [])

    const _openModalModalAddToList = (payload) => {
        setPayload(payload);
        if (LoginService.isLogged()) {
            setHeaderCheckout(payload.value.headerCheckout);
        }
    }

    return (
        <Modal customClass={'modal-add-to-list' + (headerCheckout ? ' header-checkout' : '')} actionOpen={actionsType.MODAL.ADD_TO_LIST_OPEN} actionClose={actionsType.MODAL.ADD_TO_LIST_CLOSE}>
            <AddToList payload={payload}/>
        </Modal>
    )
}

export default ModalAddToList;

